<script>
import { GlFormInput } from '@gitlab/ui';
import CompanyDetailsForm from '~/javascripts/billing_account/components/company_details_form.vue';
import BillingAccountAddressForm from '~/javascripts/billing_account/components/billing_account_address_form.vue';
import BillingAccountDetails from '../../billing_account/components/billing_account_details.vue';
import TransactionCard from './transaction_card.vue';

export default {
  name: 'PurchaseDetailsCard',
  components: {
    BillingAccountAddressForm,
    CompanyDetailsForm,
    GlFormInput,
    TransactionCard,
    BillingAccountDetails,
  },
  inject: ['customerBillingAccountsPresent'],
  props: {
    currentNamespaceName: {
      type: String,
      required: true,
    },
    initialQuantity: {
      type: Number,
      required: true,
    },
    productTitle: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    purchaseDetails: {
      type: String,
      required: false,
      default: '',
    },
    addressFormData: {
      type: Object,
      required: true,
    },
    companyDetailsFormData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      quantity: this.initialQuantity,
    };
  },
  methods: {
    quantityChange(value) {
      this.quantity = parseInt(value, 10);

      if (Number.isNaN(this.quantity) || this.quantity <= 0) {
        this.quantity = 1;
      }

      this.$emit('quantityChange', this.quantity);
    },
    handleAddressFormChange(data, isValid) {
      this.$emit('addressFormChange', data, isValid);
    },
    handleCompanyFormChange(data, isValid) {
      this.$emit('companyFormChange', data, isValid);
    },
  },
};
</script>

<template>
  <transaction-card :title="__('Subscription details')">
    <span data-testid="namespace-name">
      {{ __('This purchase is for:') }} <strong>{{ currentNamespaceName }}</strong></span
    >
    <div ref="label-group" class="row gl-mt-4">
      <div class="col-9 gl-mb-3 gl-font-bold">{{ productTitle }}</div>
      <div class="col-3 gl-pl-0 gl-font-bold">{{ __('Quantity') }}</div>
    </div>
    <div ref="input-group" class="row">
      <span class="col-9 gl-my-auto">{{ productName }}</span>
      <gl-form-input
        v-model="quantity"
        type="number"
        min="1"
        :number="true"
        class="col-2"
        data-testid="quantity"
        @change="quantityChange"
      />
    </div>
    <div v-if="purchaseDetails" class="text-muted gl-mt-2 gl-text-sm">{{ purchaseDetails }}</div>

    <div class="gl-mt-5 gl-border-t-1 gl-border-gray-100 gl-pt-5 gl-border-t-solid">
      <billing-account-details v-if="customerBillingAccountsPresent" />
      <template v-else>
        <billing-account-address-form
          :initial-form-data="addressFormData"
          :show-required-labels="true"
          @change="handleAddressFormChange"
        />
        <company-details-form
          :initial-form-data="companyDetailsFormData"
          :show-required-labels="true"
          :selected-country="addressFormData.country"
          @change="handleCompanyFormChange"
        />
      </template>
    </div>
  </transaction-card>
</template>
